import { styled } from "@mui/material";
import { Link } from "react-router-dom";
import EditIcon from "@mui/icons-material/Edit";

export const PartnerEditButton = styled(Link)(() => ({
  position: "absolute",
  bottom: 0,
  right: 0
}));

export const PartnerEditButtonIcon = styled(EditIcon)(({ theme }) => ({
  width: theme.spacing(2.5),
  height: theme.spacing(2.5)
}));
